import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class LoginService 
{
    constructor(private http: HttpClient) { }

    traeDocumentos()
    {
        let headers = new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });

        return this.http.get(`https://junji.sharepoint.com/sites/centro_documental/_api/web/lists/GetByTitle('Documents')`, { headers: headers } ).toPromise();
    }    

    buscaRoles(username: any) 
    { 
        
        let headers = new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
            'Access-Control-Allow-Origin': '*',
            //'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Access-Control-Allow-Origin, apikey SOAPAction, authorization',
            'Accept': '*/*',
            'apikey' : environment.apikey
        });

        //let headers = new HttpHeaders();
        //headers = headers.set('apikey', environment.apikey);

        return this.http.get(`${environment.urlBase}/afiliados/email/${username}`, { headers: headers } ).toPromise();
    }


    buscaRolesEjecutivo(username: any) 
    { 
        
        let headers = new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
            'Access-Control-Allow-Origin': '*',
            //'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Access-Control-Allow-Origin, apikey SOAPAction, authorization',
            'Accept': '*/*',
            'apikey' : environment.apikey
        });

        return this.http.get(`${environment.urlBase}/ejecutivo/email/${username}`, { headers: headers } ).toPromise();
    }

    
    buscaRolesPensionado(username: any,key: string) 
    { 
        
        let headers = new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + key,
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
            'Access-Control-Allow-Origin': '*',
            'Accept': '*/*',
            'apikey' : environment.apikey
        });

        return this.http.get(`${environment.urlBase}/afiliados/email/${username}`, { headers: headers } ).toPromise();
    }
  
    jwtServicios(user: any, pass: any ,apiKey: any) 
    { 
        let headersKey = new HttpHeaders({            
            'Content-Type':'application/json',
            'Access-Control-Allow-Methods': 'GET, POST,OPTIONS',
            'accept': '*/*',
            'apikey' : apiKey
        });
     
            return this.http.post<string>(`${environment.urlIntegracion}/v1/token/`,
            { 
                    password: pass,
                    userName: user
            },
            { headers: headersKey }).toPromise();
        
    }

}

